<template>
<div>
    <ShowAllOrders orderStatus="organization"></ShowAllOrders>
</div>
</template>

<script>
import ShowAllOrders from '@/components/App/dashboard/ShowAllOrders.vue';
export default {
    name: "OrganizationTab",
    components: {
        ShowAllOrders
    }
}
</script>

<style>
</style>